import type { CustomIconProps } from '../CustomIcon';

export const ChevronRightIcon = ({
  color,
  size = 24,
  ternaryColor,
  solid,
  secondaryColor,
  ...props
}: CustomIconProps) => (
  <svg
    width={size}
    height={size}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 24 24'
    {...props}>
    <path
      d='M9 18L15 12L9 6'
      stroke={color}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
